/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAgendaRouteImport } from './routes/_app/agenda'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppMyWorkRouteImport } from './routes/_app/my-work'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppWerkRouteImport } from './routes/_app/werk'
import { Route as PortalClientRouteImport } from './routes/portal/_client'
import { Route as PortalLoginRouteImport } from './routes/portal/login'
import { Route as PortalPrivacyRouteImport } from './routes/portal/privacy'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminApiCallsRouteImport } from './routes/_app/admin/api-calls'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminCompanyRouteImport } from './routes/_app/admin/company'
import { Route as AppAdminConnectionsRouteImport } from './routes/_app/admin/connections'
import { Route as AppAdminInboundMailsRouteImport } from './routes/_app/admin/inbound-mails'
import { Route as AppAdminInboundRecordingsRouteImport } from './routes/_app/admin/inbound-recordings'
import { Route as AppAdminMailboxesRouteImport } from './routes/_app/admin/mailboxes'
import { Route as AppAdminSchedulesRouteImport } from './routes/_app/admin/schedules'
import { Route as AppAdminSecretsRouteImport } from './routes/_app/admin/secrets'
import { Route as AppAdminTemplatesRouteImport } from './routes/_app/admin/templates'
import { Route as AppAdminWebhooksRouteImport } from './routes/_app/admin/webhooks'
import { Route as AppAdminWorkTypesRouteImport } from './routes/_app/admin/work-types'
import { Route as AppAgentsIndexRouteImport } from './routes/_app/agents/index'
import { Route as AppAgentsIdRouteImport } from './routes/_app/agents/$id'
import { Route as AppAgentsInsightsRouteImport } from './routes/_app/agents/insights'
import { Route as AppAgentsRoutinesRouteImport } from './routes/_app/agents/routines'
import { Route as AppAgreementsIndexRouteImport } from './routes/_app/agreements/index'
import { Route as AppAgreementsIdRouteImport } from './routes/_app/agreements/$id'
import { Route as AppApprovalsIndexRouteImport } from './routes/_app/approvals/index'
import { Route as AppApprovalsIdRouteImport } from './routes/_app/approvals/$id'
import { Route as AppBillingExpensesRouteImport } from './routes/_app/billing/expenses'
import { Route as AppBillingMileageRouteImport } from './routes/_app/billing/mileage'
import { Route as AppBillingReportsRouteImport } from './routes/_app/billing/reports'
import { Route as AppDevActivityRouteImport } from './routes/_app/dev/activity'
import { Route as AppDevBoardRouteImport } from './routes/_app/dev/board'
import { Route as AppDevComplianceRouteImport } from './routes/_app/dev/compliance'
import { Route as AppDevMilestonesRouteImport } from './routes/_app/dev/milestones'
import { Route as AppDevSettingsRouteImport } from './routes/_app/dev/settings'
import { Route as AppEngagementsIndexRouteImport } from './routes/_app/engagements/index'
import { Route as AppEngagementsIdRouteImport } from './routes/_app/engagements/$id'
import { Route as AppFeedbackIndexRouteImport } from './routes/_app/feedback/index'
import { Route as AppFeedbackIdRouteImport } from './routes/_app/feedback/$id'
import { Route as AppKnowledgeIndexRouteImport } from './routes/_app/knowledge/index'
import { Route as AppKnowledgeAdminRouteImport } from './routes/_app/knowledge/admin'
import { Route as AppKnowledgeSearchRouteImport } from './routes/_app/knowledge/search'
import { Route as AppOrgIndexRouteImport } from './routes/_app/org/index'
import { Route as AppOrgIdRouteImport } from './routes/_app/org/$id'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsIdRouteImport } from './routes/_app/projects/$id'
import { Route as AppProposalsIndexRouteImport } from './routes/_app/proposals/index'
import { Route as AppProposalsIdRouteImport } from './routes/_app/proposals/$id'
import { Route as AppSupportIndexRouteImport } from './routes/_app/support/index'
import { Route as AppSupportIdRouteImport } from './routes/_app/support/$id'
import { Route as AppSupportSlaRouteImport } from './routes/_app/support/sla'
import { Route as AppSupportTemplatesRouteImport } from './routes/_app/support/templates'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as AppTasksIdRouteImport } from './routes/_app/tasks/$id'
import { Route as AppTimeIndexRouteImport } from './routes/_app/time/index'
import { Route as AppTimeCalendarRouteImport } from './routes/_app/time/calendar'
import { Route as AppTimeDraftsRouteImport } from './routes/_app/time/drafts'
import { Route as AppTimeWeekRouteImport } from './routes/_app/time/week'
import { Route as PortalClientIndexRouteImport } from './routes/portal/_client/index'
import { Route as PortalClientIssuesRouteImport } from './routes/portal/_client/issues'
import { Route as PortalInviteTokenRouteImport } from './routes/portal/invite.$token'
import { Route as AppAdminChoiceListsIndexRouteImport } from './routes/_app/admin/choice-lists/index'
import { Route as AppAdminChoiceListsIdRouteImport } from './routes/_app/admin/choice-lists/$id'
import { Route as AppAdminJobsIndexRouteImport } from './routes/_app/admin/jobs/index'
import { Route as AppAdminJobsIdRouteImport } from './routes/_app/admin/jobs/$id'
import { Route as AppAdminJobsQueueRouteImport } from './routes/_app/admin/jobs/queue'
import { Route as AppAdminRolesIndexRouteImport } from './routes/_app/admin/roles/index'
import { Route as AppAdminRolesIdRouteImport } from './routes/_app/admin/roles/$id'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminUsersIdRouteImport } from './routes/_app/admin/users/$id'
import { Route as AppAgentsIdChatRouteImport } from './routes/_app/agents/$id_.chat'
import { Route as AppAgentsRunsIndexRouteImport } from './routes/_app/agents/runs/index'
import { Route as AppAgentsRunsIdRouteImport } from './routes/_app/agents/runs/$id'
import { Route as AppAgentsTasksIndexRouteImport } from './routes/_app/agents/tasks/index'
import { Route as AppAgentsTasksIdRouteImport } from './routes/_app/agents/tasks/$id'
import { Route as AppBillingInvoicesIndexRouteImport } from './routes/_app/billing/invoices/index'
import { Route as AppBillingInvoicesIdRouteImport } from './routes/_app/billing/invoices/$id'
import { Route as AppCrmLeadsIndexRouteImport } from './routes/_app/crm/leads/index'
import { Route as AppCrmLeadsIdRouteImport } from './routes/_app/crm/leads/$id'
import { Route as AppCrmMeetingsIndexRouteImport } from './routes/_app/crm/meetings/index'
import { Route as AppCrmMeetingsIdRouteImport } from './routes/_app/crm/meetings/$id'
import { Route as AppDevIssuesIndexRouteImport } from './routes/_app/dev/issues/index'
import { Route as AppDevIssuesIdRouteImport } from './routes/_app/dev/issues/$id'
import { Route as AppDevMilestonesIdRouteImport } from './routes/_app/dev/milestones_.$id'
import { Route as AppDevPullsIndexRouteImport } from './routes/_app/dev/pulls/index'
import { Route as AppDevPullsIdRouteImport } from './routes/_app/dev/pulls/$id'
import { Route as AppKnowledgeDocumentsIdRouteImport } from './routes/_app/knowledge/documents/$id'
import { Route as AppKnowledgeEntitiesIndexRouteImport } from './routes/_app/knowledge/entities/index'
import { Route as AppKnowledgeEntitiesIdRouteImport } from './routes/_app/knowledge/entities/$id'
import { Route as AppKnowledgeItemsIdRouteImport } from './routes/_app/knowledge/items/$id'
import { Route as AppSupportArticlesIndexRouteImport } from './routes/_app/support/articles/index'
import { Route as AppSupportArticlesIdRouteImport } from './routes/_app/support/articles/$id'
import { Route as AppTimeDayDateRouteImport } from './routes/_app/time/day.$date'
import { Route as PortalClientArticlesIndexRouteImport } from './routes/portal/_client/articles/index'
import { Route as PortalClientArticlesIdRouteImport } from './routes/portal/_client/articles/$id'
import { Route as PortalClientHoursIndexRouteImport } from './routes/portal/_client/hours/index'
import { Route as PortalClientHoursIdRouteImport } from './routes/portal/_client/hours/$id'
import { Route as PortalClientInvoicesIndexRouteImport } from './routes/portal/_client/invoices/index'
import { Route as PortalClientProjectsIndexRouteImport } from './routes/portal/_client/projects/index'
import { Route as PortalClientProjectsIdRouteImport } from './routes/portal/_client/projects/$id'
import { Route as PortalClientProposalsIndexRouteImport } from './routes/portal/_client/proposals/index'
import { Route as PortalClientProposalsIdRouteImport } from './routes/portal/_client/proposals/$id'
import { Route as PortalClientTicketsIndexRouteImport } from './routes/portal/_client/tickets/index'
import { Route as PortalClientTicketsIdRouteImport } from './routes/portal/_client/tickets/$id'
import { Route as PortalClientTicketsNewRouteImport } from './routes/portal/_client/tickets/new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendaRoute = AppAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkRoute = AppMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppWerkRoute = AppWerkRouteImport.update({
  id: '/werk',
  path: '/werk',
  getParentRoute: () => AppRoute,
} as any)
const PortalClientRoute = PortalClientRouteImport.update({
  id: '/portal/_client',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalLoginRoute = PortalLoginRouteImport.update({
  id: '/portal/login',
  path: '/portal/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalPrivacyRoute = PortalPrivacyRouteImport.update({
  id: '/portal/privacy',
  path: '/portal/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminApiCallsRoute = AppAdminApiCallsRouteImport.update({
  id: '/api-calls',
  path: '/api-calls',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCompanyRoute = AppAdminCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminConnectionsRoute = AppAdminConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInboundMailsRoute = AppAdminInboundMailsRouteImport.update({
  id: '/inbound-mails',
  path: '/inbound-mails',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInboundRecordingsRoute =
  AppAdminInboundRecordingsRouteImport.update({
    id: '/inbound-recordings',
    path: '/inbound-recordings',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminMailboxesRoute = AppAdminMailboxesRouteImport.update({
  id: '/mailboxes',
  path: '/mailboxes',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSchedulesRoute = AppAdminSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSecretsRoute = AppAdminSecretsRouteImport.update({
  id: '/secrets',
  path: '/secrets',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTemplatesRoute = AppAdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWebhooksRoute = AppAdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWorkTypesRoute = AppAdminWorkTypesRouteImport.update({
  id: '/work-types',
  path: '/work-types',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsIdRoute = AppAgentsIdRouteImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsInsightsRoute = AppAgentsInsightsRouteImport.update({
  id: '/agents/insights',
  path: '/agents/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRoutinesRoute = AppAgentsRoutinesRouteImport.update({
  id: '/agents/routines',
  path: '/agents/routines',
  getParentRoute: () => AppRoute,
} as any)
const AppAgreementsIndexRoute = AppAgreementsIndexRouteImport.update({
  id: '/agreements/',
  path: '/agreements/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgreementsIdRoute = AppAgreementsIdRouteImport.update({
  id: '/agreements/$id',
  path: '/agreements/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsIdRoute = AppApprovalsIdRouteImport.update({
  id: '/approvals/$id',
  path: '/approvals/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingExpensesRoute = AppBillingExpensesRouteImport.update({
  id: '/billing/expenses',
  path: '/billing/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingMileageRoute = AppBillingMileageRouteImport.update({
  id: '/billing/mileage',
  path: '/billing/mileage',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingReportsRoute = AppBillingReportsRouteImport.update({
  id: '/billing/reports',
  path: '/billing/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppDevActivityRoute = AppDevActivityRouteImport.update({
  id: '/dev/activity',
  path: '/dev/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppDevBoardRoute = AppDevBoardRouteImport.update({
  id: '/dev/board',
  path: '/dev/board',
  getParentRoute: () => AppRoute,
} as any)
const AppDevComplianceRoute = AppDevComplianceRouteImport.update({
  id: '/dev/compliance',
  path: '/dev/compliance',
  getParentRoute: () => AppRoute,
} as any)
const AppDevMilestonesRoute = AppDevMilestonesRouteImport.update({
  id: '/dev/milestones',
  path: '/dev/milestones',
  getParentRoute: () => AppRoute,
} as any)
const AppDevSettingsRoute = AppDevSettingsRouteImport.update({
  id: '/dev/settings',
  path: '/dev/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppEngagementsIndexRoute = AppEngagementsIndexRouteImport.update({
  id: '/engagements/',
  path: '/engagements/',
  getParentRoute: () => AppRoute,
} as any)
const AppEngagementsIdRoute = AppEngagementsIdRouteImport.update({
  id: '/engagements/$id',
  path: '/engagements/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedbackIndexRoute = AppFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedbackIdRoute = AppFeedbackIdRouteImport.update({
  id: '/feedback/$id',
  path: '/feedback/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeIndexRoute = AppKnowledgeIndexRouteImport.update({
  id: '/knowledge/',
  path: '/knowledge/',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeAdminRoute = AppKnowledgeAdminRouteImport.update({
  id: '/knowledge/admin',
  path: '/knowledge/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeSearchRoute = AppKnowledgeSearchRouteImport.update({
  id: '/knowledge/search',
  path: '/knowledge/search',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgIndexRoute = AppOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgIdRoute = AppOrgIdRouteImport.update({
  id: '/org/$id',
  path: '/org/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdRoute = AppProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIndexRoute = AppProposalsIndexRouteImport.update({
  id: '/proposals/',
  path: '/proposals/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIdRoute = AppProposalsIdRouteImport.update({
  id: '/proposals/$id',
  path: '/proposals/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIndexRoute = AppSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIdRoute = AppSupportIdRouteImport.update({
  id: '/support/$id',
  path: '/support/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportSlaRoute = AppSupportSlaRouteImport.update({
  id: '/support/sla',
  path: '/support/sla',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportTemplatesRoute = AppSupportTemplatesRouteImport.update({
  id: '/support/templates',
  path: '/support/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksIdRoute = AppTasksIdRouteImport.update({
  id: '/tasks/$id',
  path: '/tasks/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeIndexRoute = AppTimeIndexRouteImport.update({
  id: '/time/',
  path: '/time/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeCalendarRoute = AppTimeCalendarRouteImport.update({
  id: '/time/calendar',
  path: '/time/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeDraftsRoute = AppTimeDraftsRouteImport.update({
  id: '/time/drafts',
  path: '/time/drafts',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeWeekRoute = AppTimeWeekRouteImport.update({
  id: '/time/week',
  path: '/time/week',
  getParentRoute: () => AppRoute,
} as any)
const PortalClientIndexRoute = PortalClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientIssuesRoute = PortalClientIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalInviteTokenRoute = PortalInviteTokenRouteImport.update({
  id: '/portal/invite/$token',
  path: '/portal/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminChoiceListsIndexRoute =
  AppAdminChoiceListsIndexRouteImport.update({
    id: '/choice-lists/',
    path: '/choice-lists/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminChoiceListsIdRoute = AppAdminChoiceListsIdRouteImport.update({
  id: '/choice-lists/$id',
  path: '/choice-lists/$id',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminJobsIndexRoute = AppAdminJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminJobsIdRoute = AppAdminJobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminJobsQueueRoute = AppAdminJobsQueueRouteImport.update({
  id: '/jobs/queue',
  path: '/jobs/queue',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesIndexRoute = AppAdminRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesIdRoute = AppAdminRolesIdRouteImport.update({
  id: '/roles/$id',
  path: '/roles/$id',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIdRoute = AppAdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAgentsIdChatRoute = AppAgentsIdChatRouteImport.update({
  id: '/agents/$id_/chat',
  path: '/agents/$id/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRunsIndexRoute = AppAgentsRunsIndexRouteImport.update({
  id: '/agents/runs/',
  path: '/agents/runs/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRunsIdRoute = AppAgentsRunsIdRouteImport.update({
  id: '/agents/runs/$id',
  path: '/agents/runs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsTasksIndexRoute = AppAgentsTasksIndexRouteImport.update({
  id: '/agents/tasks/',
  path: '/agents/tasks/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsTasksIdRoute = AppAgentsTasksIdRouteImport.update({
  id: '/agents/tasks/$id',
  path: '/agents/tasks/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingInvoicesIndexRoute = AppBillingInvoicesIndexRouteImport.update({
  id: '/billing/invoices/',
  path: '/billing/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingInvoicesIdRoute = AppBillingInvoicesIdRouteImport.update({
  id: '/billing/invoices/$id',
  path: '/billing/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmLeadsIndexRoute = AppCrmLeadsIndexRouteImport.update({
  id: '/crm/leads/',
  path: '/crm/leads/',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmLeadsIdRoute = AppCrmLeadsIdRouteImport.update({
  id: '/crm/leads/$id',
  path: '/crm/leads/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmMeetingsIndexRoute = AppCrmMeetingsIndexRouteImport.update({
  id: '/crm/meetings/',
  path: '/crm/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppCrmMeetingsIdRoute = AppCrmMeetingsIdRouteImport.update({
  id: '/crm/meetings/$id',
  path: '/crm/meetings/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDevIssuesIndexRoute = AppDevIssuesIndexRouteImport.update({
  id: '/dev/issues/',
  path: '/dev/issues/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevIssuesIdRoute = AppDevIssuesIdRouteImport.update({
  id: '/dev/issues/$id',
  path: '/dev/issues/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDevMilestonesIdRoute = AppDevMilestonesIdRouteImport.update({
  id: '/dev/milestones_/$id',
  path: '/dev/milestones/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDevPullsIndexRoute = AppDevPullsIndexRouteImport.update({
  id: '/dev/pulls/',
  path: '/dev/pulls/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevPullsIdRoute = AppDevPullsIdRouteImport.update({
  id: '/dev/pulls/$id',
  path: '/dev/pulls/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeDocumentsIdRoute = AppKnowledgeDocumentsIdRouteImport.update({
  id: '/knowledge/documents/$id',
  path: '/knowledge/documents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeEntitiesIndexRoute =
  AppKnowledgeEntitiesIndexRouteImport.update({
    id: '/knowledge/entities/',
    path: '/knowledge/entities/',
    getParentRoute: () => AppRoute,
  } as any)
const AppKnowledgeEntitiesIdRoute = AppKnowledgeEntitiesIdRouteImport.update({
  id: '/knowledge/entities/$id',
  path: '/knowledge/entities/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeItemsIdRoute = AppKnowledgeItemsIdRouteImport.update({
  id: '/knowledge/items/$id',
  path: '/knowledge/items/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportArticlesIndexRoute = AppSupportArticlesIndexRouteImport.update({
  id: '/support/articles/',
  path: '/support/articles/',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportArticlesIdRoute = AppSupportArticlesIdRouteImport.update({
  id: '/support/articles/$id',
  path: '/support/articles/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeDayDateRoute = AppTimeDayDateRouteImport.update({
  id: '/time/day/$date',
  path: '/time/day/$date',
  getParentRoute: () => AppRoute,
} as any)
const PortalClientArticlesIndexRoute =
  PortalClientArticlesIndexRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => PortalClientRoute,
  } as any)
const PortalClientArticlesIdRoute = PortalClientArticlesIdRouteImport.update({
  id: '/articles/$id',
  path: '/articles/$id',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientHoursIndexRoute = PortalClientHoursIndexRouteImport.update({
  id: '/hours/',
  path: '/hours/',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientHoursIdRoute = PortalClientHoursIdRouteImport.update({
  id: '/hours/$id',
  path: '/hours/$id',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientInvoicesIndexRoute =
  PortalClientInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => PortalClientRoute,
  } as any)
const PortalClientProjectsIndexRoute =
  PortalClientProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => PortalClientRoute,
  } as any)
const PortalClientProjectsIdRoute = PortalClientProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientProposalsIndexRoute =
  PortalClientProposalsIndexRouteImport.update({
    id: '/proposals/',
    path: '/proposals/',
    getParentRoute: () => PortalClientRoute,
  } as any)
const PortalClientProposalsIdRoute = PortalClientProposalsIdRouteImport.update({
  id: '/proposals/$id',
  path: '/proposals/$id',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientTicketsIndexRoute =
  PortalClientTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => PortalClientRoute,
  } as any)
const PortalClientTicketsIdRoute = PortalClientTicketsIdRouteImport.update({
  id: '/tickets/$id',
  path: '/tickets/$id',
  getParentRoute: () => PortalClientRoute,
} as any)
const PortalClientTicketsNewRoute = PortalClientTicketsNewRouteImport.update({
  id: '/tickets/new',
  path: '/tickets/new',
  getParentRoute: () => PortalClientRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/consent': typeof ConsentRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/agenda': typeof AppAgendaRoute
  '/inbox': typeof AppInboxRoute
  '/my-work': typeof AppMyWorkRoute
  '/reports': typeof AppReportsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/werk': typeof AppWerkRoute
  '/portal': typeof PortalClientRouteWithChildren
  '/portal/login': typeof PortalLoginRoute
  '/portal/privacy': typeof PortalPrivacyRoute
  '/admin/api-calls': typeof AppAdminApiCallsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/company': typeof AppAdminCompanyRoute
  '/admin/connections': typeof AppAdminConnectionsRoute
  '/admin/inbound-mails': typeof AppAdminInboundMailsRoute
  '/admin/inbound-recordings': typeof AppAdminInboundRecordingsRoute
  '/admin/mailboxes': typeof AppAdminMailboxesRoute
  '/admin/schedules': typeof AppAdminSchedulesRoute
  '/admin/secrets': typeof AppAdminSecretsRoute
  '/admin/templates': typeof AppAdminTemplatesRoute
  '/admin/webhooks': typeof AppAdminWebhooksRoute
  '/admin/work-types': typeof AppAdminWorkTypesRoute
  '/agents/$id': typeof AppAgentsIdRoute
  '/agents/insights': typeof AppAgentsInsightsRoute
  '/agents/routines': typeof AppAgentsRoutinesRoute
  '/agreements/$id': typeof AppAgreementsIdRoute
  '/approvals/$id': typeof AppApprovalsIdRoute
  '/billing/expenses': typeof AppBillingExpensesRoute
  '/billing/mileage': typeof AppBillingMileageRoute
  '/billing/reports': typeof AppBillingReportsRoute
  '/dev/activity': typeof AppDevActivityRoute
  '/dev/board': typeof AppDevBoardRoute
  '/dev/compliance': typeof AppDevComplianceRoute
  '/dev/milestones': typeof AppDevMilestonesRoute
  '/dev/settings': typeof AppDevSettingsRoute
  '/engagements/$id': typeof AppEngagementsIdRoute
  '/feedback/$id': typeof AppFeedbackIdRoute
  '/knowledge/admin': typeof AppKnowledgeAdminRoute
  '/knowledge/search': typeof AppKnowledgeSearchRoute
  '/org/$id': typeof AppOrgIdRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/proposals/$id': typeof AppProposalsIdRoute
  '/support/$id': typeof AppSupportIdRoute
  '/support/sla': typeof AppSupportSlaRoute
  '/support/templates': typeof AppSupportTemplatesRoute
  '/tasks/$id': typeof AppTasksIdRoute
  '/time/calendar': typeof AppTimeCalendarRoute
  '/time/drafts': typeof AppTimeDraftsRoute
  '/time/week': typeof AppTimeWeekRoute
  '/portal/issues': typeof PortalClientIssuesRoute
  '/portal/invite/$token': typeof PortalInviteTokenRoute
  '/admin/': typeof AppAdminIndexRoute
  '/agents/': typeof AppAgentsIndexRoute
  '/agreements/': typeof AppAgreementsIndexRoute
  '/approvals/': typeof AppApprovalsIndexRoute
  '/engagements/': typeof AppEngagementsIndexRoute
  '/feedback/': typeof AppFeedbackIndexRoute
  '/knowledge/': typeof AppKnowledgeIndexRoute
  '/org/': typeof AppOrgIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/proposals/': typeof AppProposalsIndexRoute
  '/support/': typeof AppSupportIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/time/': typeof AppTimeIndexRoute
  '/portal/': typeof PortalClientIndexRoute
  '/admin/choice-lists/$id': typeof AppAdminChoiceListsIdRoute
  '/admin/jobs/$id': typeof AppAdminJobsIdRoute
  '/admin/jobs/queue': typeof AppAdminJobsQueueRoute
  '/admin/roles/$id': typeof AppAdminRolesIdRoute
  '/admin/users/$id': typeof AppAdminUsersIdRoute
  '/agents/$id/chat': typeof AppAgentsIdChatRoute
  '/agents/runs/$id': typeof AppAgentsRunsIdRoute
  '/agents/tasks/$id': typeof AppAgentsTasksIdRoute
  '/billing/invoices/$id': typeof AppBillingInvoicesIdRoute
  '/crm/leads/$id': typeof AppCrmLeadsIdRoute
  '/crm/meetings/$id': typeof AppCrmMeetingsIdRoute
  '/dev/issues/$id': typeof AppDevIssuesIdRoute
  '/dev/milestones/$id': typeof AppDevMilestonesIdRoute
  '/dev/pulls/$id': typeof AppDevPullsIdRoute
  '/knowledge/documents/$id': typeof AppKnowledgeDocumentsIdRoute
  '/knowledge/entities/$id': typeof AppKnowledgeEntitiesIdRoute
  '/knowledge/items/$id': typeof AppKnowledgeItemsIdRoute
  '/support/articles/$id': typeof AppSupportArticlesIdRoute
  '/time/day/$date': typeof AppTimeDayDateRoute
  '/portal/articles/$id': typeof PortalClientArticlesIdRoute
  '/portal/hours/$id': typeof PortalClientHoursIdRoute
  '/portal/projects/$id': typeof PortalClientProjectsIdRoute
  '/portal/proposals/$id': typeof PortalClientProposalsIdRoute
  '/portal/tickets/$id': typeof PortalClientTicketsIdRoute
  '/portal/tickets/new': typeof PortalClientTicketsNewRoute
  '/admin/choice-lists/': typeof AppAdminChoiceListsIndexRoute
  '/admin/jobs/': typeof AppAdminJobsIndexRoute
  '/admin/roles/': typeof AppAdminRolesIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/agents/runs/': typeof AppAgentsRunsIndexRoute
  '/agents/tasks/': typeof AppAgentsTasksIndexRoute
  '/billing/invoices/': typeof AppBillingInvoicesIndexRoute
  '/crm/leads/': typeof AppCrmLeadsIndexRoute
  '/crm/meetings/': typeof AppCrmMeetingsIndexRoute
  '/dev/issues/': typeof AppDevIssuesIndexRoute
  '/dev/pulls/': typeof AppDevPullsIndexRoute
  '/knowledge/entities/': typeof AppKnowledgeEntitiesIndexRoute
  '/support/articles/': typeof AppSupportArticlesIndexRoute
  '/portal/articles/': typeof PortalClientArticlesIndexRoute
  '/portal/hours/': typeof PortalClientHoursIndexRoute
  '/portal/invoices/': typeof PortalClientInvoicesIndexRoute
  '/portal/projects/': typeof PortalClientProjectsIndexRoute
  '/portal/proposals/': typeof PortalClientProposalsIndexRoute
  '/portal/tickets/': typeof PortalClientTicketsIndexRoute
}
export interface FileRoutesByTo {
  '/consent': typeof ConsentRoute
  '/login': typeof LoginRoute
  '/agenda': typeof AppAgendaRoute
  '/inbox': typeof AppInboxRoute
  '/my-work': typeof AppMyWorkRoute
  '/reports': typeof AppReportsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/werk': typeof AppWerkRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/privacy': typeof PortalPrivacyRoute
  '/': typeof AppIndexRoute
  '/admin/api-calls': typeof AppAdminApiCallsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/company': typeof AppAdminCompanyRoute
  '/admin/connections': typeof AppAdminConnectionsRoute
  '/admin/inbound-mails': typeof AppAdminInboundMailsRoute
  '/admin/inbound-recordings': typeof AppAdminInboundRecordingsRoute
  '/admin/mailboxes': typeof AppAdminMailboxesRoute
  '/admin/schedules': typeof AppAdminSchedulesRoute
  '/admin/secrets': typeof AppAdminSecretsRoute
  '/admin/templates': typeof AppAdminTemplatesRoute
  '/admin/webhooks': typeof AppAdminWebhooksRoute
  '/admin/work-types': typeof AppAdminWorkTypesRoute
  '/agents/$id': typeof AppAgentsIdRoute
  '/agents/insights': typeof AppAgentsInsightsRoute
  '/agents/routines': typeof AppAgentsRoutinesRoute
  '/agreements/$id': typeof AppAgreementsIdRoute
  '/approvals/$id': typeof AppApprovalsIdRoute
  '/billing/expenses': typeof AppBillingExpensesRoute
  '/billing/mileage': typeof AppBillingMileageRoute
  '/billing/reports': typeof AppBillingReportsRoute
  '/dev/activity': typeof AppDevActivityRoute
  '/dev/board': typeof AppDevBoardRoute
  '/dev/compliance': typeof AppDevComplianceRoute
  '/dev/milestones': typeof AppDevMilestonesRoute
  '/dev/settings': typeof AppDevSettingsRoute
  '/engagements/$id': typeof AppEngagementsIdRoute
  '/feedback/$id': typeof AppFeedbackIdRoute
  '/knowledge/admin': typeof AppKnowledgeAdminRoute
  '/knowledge/search': typeof AppKnowledgeSearchRoute
  '/org/$id': typeof AppOrgIdRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/proposals/$id': typeof AppProposalsIdRoute
  '/support/$id': typeof AppSupportIdRoute
  '/support/sla': typeof AppSupportSlaRoute
  '/support/templates': typeof AppSupportTemplatesRoute
  '/tasks/$id': typeof AppTasksIdRoute
  '/time/calendar': typeof AppTimeCalendarRoute
  '/time/drafts': typeof AppTimeDraftsRoute
  '/time/week': typeof AppTimeWeekRoute
  '/portal/issues': typeof PortalClientIssuesRoute
  '/portal/invite/$token': typeof PortalInviteTokenRoute
  '/admin': typeof AppAdminIndexRoute
  '/agents': typeof AppAgentsIndexRoute
  '/agreements': typeof AppAgreementsIndexRoute
  '/approvals': typeof AppApprovalsIndexRoute
  '/engagements': typeof AppEngagementsIndexRoute
  '/feedback': typeof AppFeedbackIndexRoute
  '/knowledge': typeof AppKnowledgeIndexRoute
  '/org': typeof AppOrgIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/proposals': typeof AppProposalsIndexRoute
  '/support': typeof AppSupportIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/time': typeof AppTimeIndexRoute
  '/portal': typeof PortalClientIndexRoute
  '/admin/choice-lists/$id': typeof AppAdminChoiceListsIdRoute
  '/admin/jobs/$id': typeof AppAdminJobsIdRoute
  '/admin/jobs/queue': typeof AppAdminJobsQueueRoute
  '/admin/roles/$id': typeof AppAdminRolesIdRoute
  '/admin/users/$id': typeof AppAdminUsersIdRoute
  '/agents/$id/chat': typeof AppAgentsIdChatRoute
  '/agents/runs/$id': typeof AppAgentsRunsIdRoute
  '/agents/tasks/$id': typeof AppAgentsTasksIdRoute
  '/billing/invoices/$id': typeof AppBillingInvoicesIdRoute
  '/crm/leads/$id': typeof AppCrmLeadsIdRoute
  '/crm/meetings/$id': typeof AppCrmMeetingsIdRoute
  '/dev/issues/$id': typeof AppDevIssuesIdRoute
  '/dev/milestones/$id': typeof AppDevMilestonesIdRoute
  '/dev/pulls/$id': typeof AppDevPullsIdRoute
  '/knowledge/documents/$id': typeof AppKnowledgeDocumentsIdRoute
  '/knowledge/entities/$id': typeof AppKnowledgeEntitiesIdRoute
  '/knowledge/items/$id': typeof AppKnowledgeItemsIdRoute
  '/support/articles/$id': typeof AppSupportArticlesIdRoute
  '/time/day/$date': typeof AppTimeDayDateRoute
  '/portal/articles/$id': typeof PortalClientArticlesIdRoute
  '/portal/hours/$id': typeof PortalClientHoursIdRoute
  '/portal/projects/$id': typeof PortalClientProjectsIdRoute
  '/portal/proposals/$id': typeof PortalClientProposalsIdRoute
  '/portal/tickets/$id': typeof PortalClientTicketsIdRoute
  '/portal/tickets/new': typeof PortalClientTicketsNewRoute
  '/admin/choice-lists': typeof AppAdminChoiceListsIndexRoute
  '/admin/jobs': typeof AppAdminJobsIndexRoute
  '/admin/roles': typeof AppAdminRolesIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/agents/runs': typeof AppAgentsRunsIndexRoute
  '/agents/tasks': typeof AppAgentsTasksIndexRoute
  '/billing/invoices': typeof AppBillingInvoicesIndexRoute
  '/crm/leads': typeof AppCrmLeadsIndexRoute
  '/crm/meetings': typeof AppCrmMeetingsIndexRoute
  '/dev/issues': typeof AppDevIssuesIndexRoute
  '/dev/pulls': typeof AppDevPullsIndexRoute
  '/knowledge/entities': typeof AppKnowledgeEntitiesIndexRoute
  '/support/articles': typeof AppSupportArticlesIndexRoute
  '/portal/articles': typeof PortalClientArticlesIndexRoute
  '/portal/hours': typeof PortalClientHoursIndexRoute
  '/portal/invoices': typeof PortalClientInvoicesIndexRoute
  '/portal/projects': typeof PortalClientProjectsIndexRoute
  '/portal/proposals': typeof PortalClientProposalsIndexRoute
  '/portal/tickets': typeof PortalClientTicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/consent': typeof ConsentRoute
  '/login': typeof LoginRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/agenda': typeof AppAgendaRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/my-work': typeof AppMyWorkRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/werk': typeof AppWerkRoute
  '/portal/_client': typeof PortalClientRouteWithChildren
  '/portal/login': typeof PortalLoginRoute
  '/portal/privacy': typeof PortalPrivacyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/api-calls': typeof AppAdminApiCallsRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/company': typeof AppAdminCompanyRoute
  '/_app/admin/connections': typeof AppAdminConnectionsRoute
  '/_app/admin/inbound-mails': typeof AppAdminInboundMailsRoute
  '/_app/admin/inbound-recordings': typeof AppAdminInboundRecordingsRoute
  '/_app/admin/mailboxes': typeof AppAdminMailboxesRoute
  '/_app/admin/schedules': typeof AppAdminSchedulesRoute
  '/_app/admin/secrets': typeof AppAdminSecretsRoute
  '/_app/admin/templates': typeof AppAdminTemplatesRoute
  '/_app/admin/webhooks': typeof AppAdminWebhooksRoute
  '/_app/admin/work-types': typeof AppAdminWorkTypesRoute
  '/_app/agents/$id': typeof AppAgentsIdRoute
  '/_app/agents/insights': typeof AppAgentsInsightsRoute
  '/_app/agents/routines': typeof AppAgentsRoutinesRoute
  '/_app/agreements/$id': typeof AppAgreementsIdRoute
  '/_app/approvals/$id': typeof AppApprovalsIdRoute
  '/_app/billing/expenses': typeof AppBillingExpensesRoute
  '/_app/billing/mileage': typeof AppBillingMileageRoute
  '/_app/billing/reports': typeof AppBillingReportsRoute
  '/_app/dev/activity': typeof AppDevActivityRoute
  '/_app/dev/board': typeof AppDevBoardRoute
  '/_app/dev/compliance': typeof AppDevComplianceRoute
  '/_app/dev/milestones': typeof AppDevMilestonesRoute
  '/_app/dev/settings': typeof AppDevSettingsRoute
  '/_app/engagements/$id': typeof AppEngagementsIdRoute
  '/_app/feedback/$id': typeof AppFeedbackIdRoute
  '/_app/knowledge/admin': typeof AppKnowledgeAdminRoute
  '/_app/knowledge/search': typeof AppKnowledgeSearchRoute
  '/_app/org/$id': typeof AppOrgIdRoute
  '/_app/projects/$id': typeof AppProjectsIdRoute
  '/_app/proposals/$id': typeof AppProposalsIdRoute
  '/_app/support/$id': typeof AppSupportIdRoute
  '/_app/support/sla': typeof AppSupportSlaRoute
  '/_app/support/templates': typeof AppSupportTemplatesRoute
  '/_app/tasks/$id': typeof AppTasksIdRoute
  '/_app/time/calendar': typeof AppTimeCalendarRoute
  '/_app/time/drafts': typeof AppTimeDraftsRoute
  '/_app/time/week': typeof AppTimeWeekRoute
  '/portal/_client/issues': typeof PortalClientIssuesRoute
  '/portal/invite/$token': typeof PortalInviteTokenRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_app/agreements/': typeof AppAgreementsIndexRoute
  '/_app/approvals/': typeof AppApprovalsIndexRoute
  '/_app/engagements/': typeof AppEngagementsIndexRoute
  '/_app/feedback/': typeof AppFeedbackIndexRoute
  '/_app/knowledge/': typeof AppKnowledgeIndexRoute
  '/_app/org/': typeof AppOrgIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/proposals/': typeof AppProposalsIndexRoute
  '/_app/support/': typeof AppSupportIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/time/': typeof AppTimeIndexRoute
  '/portal/_client/': typeof PortalClientIndexRoute
  '/_app/admin/choice-lists/$id': typeof AppAdminChoiceListsIdRoute
  '/_app/admin/jobs/$id': typeof AppAdminJobsIdRoute
  '/_app/admin/jobs/queue': typeof AppAdminJobsQueueRoute
  '/_app/admin/roles/$id': typeof AppAdminRolesIdRoute
  '/_app/admin/users/$id': typeof AppAdminUsersIdRoute
  '/_app/agents/$id_/chat': typeof AppAgentsIdChatRoute
  '/_app/agents/runs/$id': typeof AppAgentsRunsIdRoute
  '/_app/agents/tasks/$id': typeof AppAgentsTasksIdRoute
  '/_app/billing/invoices/$id': typeof AppBillingInvoicesIdRoute
  '/_app/crm/leads/$id': typeof AppCrmLeadsIdRoute
  '/_app/crm/meetings/$id': typeof AppCrmMeetingsIdRoute
  '/_app/dev/issues/$id': typeof AppDevIssuesIdRoute
  '/_app/dev/milestones_/$id': typeof AppDevMilestonesIdRoute
  '/_app/dev/pulls/$id': typeof AppDevPullsIdRoute
  '/_app/knowledge/documents/$id': typeof AppKnowledgeDocumentsIdRoute
  '/_app/knowledge/entities/$id': typeof AppKnowledgeEntitiesIdRoute
  '/_app/knowledge/items/$id': typeof AppKnowledgeItemsIdRoute
  '/_app/support/articles/$id': typeof AppSupportArticlesIdRoute
  '/_app/time/day/$date': typeof AppTimeDayDateRoute
  '/portal/_client/articles/$id': typeof PortalClientArticlesIdRoute
  '/portal/_client/hours/$id': typeof PortalClientHoursIdRoute
  '/portal/_client/projects/$id': typeof PortalClientProjectsIdRoute
  '/portal/_client/proposals/$id': typeof PortalClientProposalsIdRoute
  '/portal/_client/tickets/$id': typeof PortalClientTicketsIdRoute
  '/portal/_client/tickets/new': typeof PortalClientTicketsNewRoute
  '/_app/admin/choice-lists/': typeof AppAdminChoiceListsIndexRoute
  '/_app/admin/jobs/': typeof AppAdminJobsIndexRoute
  '/_app/admin/roles/': typeof AppAdminRolesIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/agents/runs/': typeof AppAgentsRunsIndexRoute
  '/_app/agents/tasks/': typeof AppAgentsTasksIndexRoute
  '/_app/billing/invoices/': typeof AppBillingInvoicesIndexRoute
  '/_app/crm/leads/': typeof AppCrmLeadsIndexRoute
  '/_app/crm/meetings/': typeof AppCrmMeetingsIndexRoute
  '/_app/dev/issues/': typeof AppDevIssuesIndexRoute
  '/_app/dev/pulls/': typeof AppDevPullsIndexRoute
  '/_app/knowledge/entities/': typeof AppKnowledgeEntitiesIndexRoute
  '/_app/support/articles/': typeof AppSupportArticlesIndexRoute
  '/portal/_client/articles/': typeof PortalClientArticlesIndexRoute
  '/portal/_client/hours/': typeof PortalClientHoursIndexRoute
  '/portal/_client/invoices/': typeof PortalClientInvoicesIndexRoute
  '/portal/_client/projects/': typeof PortalClientProjectsIndexRoute
  '/portal/_client/proposals/': typeof PortalClientProposalsIndexRoute
  '/portal/_client/tickets/': typeof PortalClientTicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/consent'
    | '/login'
    | '/admin'
    | '/agenda'
    | '/inbox'
    | '/my-work'
    | '/reports'
    | '/search'
    | '/settings'
    | '/werk'
    | '/portal'
    | '/portal/login'
    | '/portal/privacy'
    | '/admin/api-calls'
    | '/admin/audit'
    | '/admin/company'
    | '/admin/connections'
    | '/admin/inbound-mails'
    | '/admin/inbound-recordings'
    | '/admin/mailboxes'
    | '/admin/schedules'
    | '/admin/secrets'
    | '/admin/templates'
    | '/admin/webhooks'
    | '/admin/work-types'
    | '/agents/$id'
    | '/agents/insights'
    | '/agents/routines'
    | '/agreements/$id'
    | '/approvals/$id'
    | '/billing/expenses'
    | '/billing/mileage'
    | '/billing/reports'
    | '/dev/activity'
    | '/dev/board'
    | '/dev/compliance'
    | '/dev/milestones'
    | '/dev/settings'
    | '/engagements/$id'
    | '/feedback/$id'
    | '/knowledge/admin'
    | '/knowledge/search'
    | '/org/$id'
    | '/projects/$id'
    | '/proposals/$id'
    | '/support/$id'
    | '/support/sla'
    | '/support/templates'
    | '/tasks/$id'
    | '/time/calendar'
    | '/time/drafts'
    | '/time/week'
    | '/portal/issues'
    | '/portal/invite/$token'
    | '/admin/'
    | '/agents/'
    | '/agreements/'
    | '/approvals/'
    | '/engagements/'
    | '/feedback/'
    | '/knowledge/'
    | '/org/'
    | '/projects/'
    | '/proposals/'
    | '/support/'
    | '/tasks/'
    | '/time/'
    | '/portal/'
    | '/admin/choice-lists/$id'
    | '/admin/jobs/$id'
    | '/admin/jobs/queue'
    | '/admin/roles/$id'
    | '/admin/users/$id'
    | '/agents/$id/chat'
    | '/agents/runs/$id'
    | '/agents/tasks/$id'
    | '/billing/invoices/$id'
    | '/crm/leads/$id'
    | '/crm/meetings/$id'
    | '/dev/issues/$id'
    | '/dev/milestones/$id'
    | '/dev/pulls/$id'
    | '/knowledge/documents/$id'
    | '/knowledge/entities/$id'
    | '/knowledge/items/$id'
    | '/support/articles/$id'
    | '/time/day/$date'
    | '/portal/articles/$id'
    | '/portal/hours/$id'
    | '/portal/projects/$id'
    | '/portal/proposals/$id'
    | '/portal/tickets/$id'
    | '/portal/tickets/new'
    | '/admin/choice-lists/'
    | '/admin/jobs/'
    | '/admin/roles/'
    | '/admin/users/'
    | '/agents/runs/'
    | '/agents/tasks/'
    | '/billing/invoices/'
    | '/crm/leads/'
    | '/crm/meetings/'
    | '/dev/issues/'
    | '/dev/pulls/'
    | '/knowledge/entities/'
    | '/support/articles/'
    | '/portal/articles/'
    | '/portal/hours/'
    | '/portal/invoices/'
    | '/portal/projects/'
    | '/portal/proposals/'
    | '/portal/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/consent'
    | '/login'
    | '/agenda'
    | '/inbox'
    | '/my-work'
    | '/reports'
    | '/search'
    | '/settings'
    | '/werk'
    | '/portal/login'
    | '/portal/privacy'
    | '/'
    | '/admin/api-calls'
    | '/admin/audit'
    | '/admin/company'
    | '/admin/connections'
    | '/admin/inbound-mails'
    | '/admin/inbound-recordings'
    | '/admin/mailboxes'
    | '/admin/schedules'
    | '/admin/secrets'
    | '/admin/templates'
    | '/admin/webhooks'
    | '/admin/work-types'
    | '/agents/$id'
    | '/agents/insights'
    | '/agents/routines'
    | '/agreements/$id'
    | '/approvals/$id'
    | '/billing/expenses'
    | '/billing/mileage'
    | '/billing/reports'
    | '/dev/activity'
    | '/dev/board'
    | '/dev/compliance'
    | '/dev/milestones'
    | '/dev/settings'
    | '/engagements/$id'
    | '/feedback/$id'
    | '/knowledge/admin'
    | '/knowledge/search'
    | '/org/$id'
    | '/projects/$id'
    | '/proposals/$id'
    | '/support/$id'
    | '/support/sla'
    | '/support/templates'
    | '/tasks/$id'
    | '/time/calendar'
    | '/time/drafts'
    | '/time/week'
    | '/portal/issues'
    | '/portal/invite/$token'
    | '/admin'
    | '/agents'
    | '/agreements'
    | '/approvals'
    | '/engagements'
    | '/feedback'
    | '/knowledge'
    | '/org'
    | '/projects'
    | '/proposals'
    | '/support'
    | '/tasks'
    | '/time'
    | '/portal'
    | '/admin/choice-lists/$id'
    | '/admin/jobs/$id'
    | '/admin/jobs/queue'
    | '/admin/roles/$id'
    | '/admin/users/$id'
    | '/agents/$id/chat'
    | '/agents/runs/$id'
    | '/agents/tasks/$id'
    | '/billing/invoices/$id'
    | '/crm/leads/$id'
    | '/crm/meetings/$id'
    | '/dev/issues/$id'
    | '/dev/milestones/$id'
    | '/dev/pulls/$id'
    | '/knowledge/documents/$id'
    | '/knowledge/entities/$id'
    | '/knowledge/items/$id'
    | '/support/articles/$id'
    | '/time/day/$date'
    | '/portal/articles/$id'
    | '/portal/hours/$id'
    | '/portal/projects/$id'
    | '/portal/proposals/$id'
    | '/portal/tickets/$id'
    | '/portal/tickets/new'
    | '/admin/choice-lists'
    | '/admin/jobs'
    | '/admin/roles'
    | '/admin/users'
    | '/agents/runs'
    | '/agents/tasks'
    | '/billing/invoices'
    | '/crm/leads'
    | '/crm/meetings'
    | '/dev/issues'
    | '/dev/pulls'
    | '/knowledge/entities'
    | '/support/articles'
    | '/portal/articles'
    | '/portal/hours'
    | '/portal/invoices'
    | '/portal/projects'
    | '/portal/proposals'
    | '/portal/tickets'
  id:
    | '__root__'
    | '/_app'
    | '/consent'
    | '/login'
    | '/_app/admin'
    | '/_app/agenda'
    | '/_app/inbox'
    | '/_app/my-work'
    | '/_app/reports'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/werk'
    | '/portal/_client'
    | '/portal/login'
    | '/portal/privacy'
    | '/_app/'
    | '/_app/admin/api-calls'
    | '/_app/admin/audit'
    | '/_app/admin/company'
    | '/_app/admin/connections'
    | '/_app/admin/inbound-mails'
    | '/_app/admin/inbound-recordings'
    | '/_app/admin/mailboxes'
    | '/_app/admin/schedules'
    | '/_app/admin/secrets'
    | '/_app/admin/templates'
    | '/_app/admin/webhooks'
    | '/_app/admin/work-types'
    | '/_app/agents/$id'
    | '/_app/agents/insights'
    | '/_app/agents/routines'
    | '/_app/agreements/$id'
    | '/_app/approvals/$id'
    | '/_app/billing/expenses'
    | '/_app/billing/mileage'
    | '/_app/billing/reports'
    | '/_app/dev/activity'
    | '/_app/dev/board'
    | '/_app/dev/compliance'
    | '/_app/dev/milestones'
    | '/_app/dev/settings'
    | '/_app/engagements/$id'
    | '/_app/feedback/$id'
    | '/_app/knowledge/admin'
    | '/_app/knowledge/search'
    | '/_app/org/$id'
    | '/_app/projects/$id'
    | '/_app/proposals/$id'
    | '/_app/support/$id'
    | '/_app/support/sla'
    | '/_app/support/templates'
    | '/_app/tasks/$id'
    | '/_app/time/calendar'
    | '/_app/time/drafts'
    | '/_app/time/week'
    | '/portal/_client/issues'
    | '/portal/invite/$token'
    | '/_app/admin/'
    | '/_app/agents/'
    | '/_app/agreements/'
    | '/_app/approvals/'
    | '/_app/engagements/'
    | '/_app/feedback/'
    | '/_app/knowledge/'
    | '/_app/org/'
    | '/_app/projects/'
    | '/_app/proposals/'
    | '/_app/support/'
    | '/_app/tasks/'
    | '/_app/time/'
    | '/portal/_client/'
    | '/_app/admin/choice-lists/$id'
    | '/_app/admin/jobs/$id'
    | '/_app/admin/jobs/queue'
    | '/_app/admin/roles/$id'
    | '/_app/admin/users/$id'
    | '/_app/agents/$id_/chat'
    | '/_app/agents/runs/$id'
    | '/_app/agents/tasks/$id'
    | '/_app/billing/invoices/$id'
    | '/_app/crm/leads/$id'
    | '/_app/crm/meetings/$id'
    | '/_app/dev/issues/$id'
    | '/_app/dev/milestones_/$id'
    | '/_app/dev/pulls/$id'
    | '/_app/knowledge/documents/$id'
    | '/_app/knowledge/entities/$id'
    | '/_app/knowledge/items/$id'
    | '/_app/support/articles/$id'
    | '/_app/time/day/$date'
    | '/portal/_client/articles/$id'
    | '/portal/_client/hours/$id'
    | '/portal/_client/projects/$id'
    | '/portal/_client/proposals/$id'
    | '/portal/_client/tickets/$id'
    | '/portal/_client/tickets/new'
    | '/_app/admin/choice-lists/'
    | '/_app/admin/jobs/'
    | '/_app/admin/roles/'
    | '/_app/admin/users/'
    | '/_app/agents/runs/'
    | '/_app/agents/tasks/'
    | '/_app/billing/invoices/'
    | '/_app/crm/leads/'
    | '/_app/crm/meetings/'
    | '/_app/dev/issues/'
    | '/_app/dev/pulls/'
    | '/_app/knowledge/entities/'
    | '/_app/support/articles/'
    | '/portal/_client/articles/'
    | '/portal/_client/hours/'
    | '/portal/_client/invoices/'
    | '/portal/_client/projects/'
    | '/portal/_client/proposals/'
    | '/portal/_client/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ConsentRoute: typeof ConsentRoute
  LoginRoute: typeof LoginRoute
  PortalClientRoute: typeof PortalClientRouteWithChildren
  PortalLoginRoute: typeof PortalLoginRoute
  PortalPrivacyRoute: typeof PortalPrivacyRoute
  PortalInviteTokenRoute: typeof PortalInviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agenda': {
      id: '/_app/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AppAgendaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work': {
      id: '/_app/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof AppMyWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/werk': {
      id: '/_app/werk'
      path: '/werk'
      fullPath: '/werk'
      preLoaderRoute: typeof AppWerkRouteImport
      parentRoute: typeof AppRoute
    }
    '/portal/_client': {
      id: '/portal/_client'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/login': {
      id: '/portal/login'
      path: '/portal/login'
      fullPath: '/portal/login'
      preLoaderRoute: typeof PortalLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/privacy': {
      id: '/portal/privacy'
      path: '/portal/privacy'
      fullPath: '/portal/privacy'
      preLoaderRoute: typeof PortalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/api-calls': {
      id: '/_app/admin/api-calls'
      path: '/api-calls'
      fullPath: '/admin/api-calls'
      preLoaderRoute: typeof AppAdminApiCallsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/company': {
      id: '/_app/admin/company'
      path: '/company'
      fullPath: '/admin/company'
      preLoaderRoute: typeof AppAdminCompanyRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/connections': {
      id: '/_app/admin/connections'
      path: '/connections'
      fullPath: '/admin/connections'
      preLoaderRoute: typeof AppAdminConnectionsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/inbound-mails': {
      id: '/_app/admin/inbound-mails'
      path: '/inbound-mails'
      fullPath: '/admin/inbound-mails'
      preLoaderRoute: typeof AppAdminInboundMailsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/inbound-recordings': {
      id: '/_app/admin/inbound-recordings'
      path: '/inbound-recordings'
      fullPath: '/admin/inbound-recordings'
      preLoaderRoute: typeof AppAdminInboundRecordingsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/mailboxes': {
      id: '/_app/admin/mailboxes'
      path: '/mailboxes'
      fullPath: '/admin/mailboxes'
      preLoaderRoute: typeof AppAdminMailboxesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/schedules': {
      id: '/_app/admin/schedules'
      path: '/schedules'
      fullPath: '/admin/schedules'
      preLoaderRoute: typeof AppAdminSchedulesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/secrets': {
      id: '/_app/admin/secrets'
      path: '/secrets'
      fullPath: '/admin/secrets'
      preLoaderRoute: typeof AppAdminSecretsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/templates': {
      id: '/_app/admin/templates'
      path: '/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AppAdminTemplatesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/webhooks': {
      id: '/_app/admin/webhooks'
      path: '/webhooks'
      fullPath: '/admin/webhooks'
      preLoaderRoute: typeof AppAdminWebhooksRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/work-types': {
      id: '/_app/admin/work-types'
      path: '/work-types'
      fullPath: '/admin/work-types'
      preLoaderRoute: typeof AppAdminWorkTypesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$id': {
      id: '/_app/agents/$id'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AppAgentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/insights': {
      id: '/_app/agents/insights'
      path: '/agents/insights'
      fullPath: '/agents/insights'
      preLoaderRoute: typeof AppAgentsInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/routines': {
      id: '/_app/agents/routines'
      path: '/agents/routines'
      fullPath: '/agents/routines'
      preLoaderRoute: typeof AppAgentsRoutinesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agreements/': {
      id: '/_app/agreements/'
      path: '/agreements'
      fullPath: '/agreements/'
      preLoaderRoute: typeof AppAgreementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agreements/$id': {
      id: '/_app/agreements/$id'
      path: '/agreements/$id'
      fullPath: '/agreements/$id'
      preLoaderRoute: typeof AppAgreementsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals/': {
      id: '/_app/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals/$id': {
      id: '/_app/approvals/$id'
      path: '/approvals/$id'
      fullPath: '/approvals/$id'
      preLoaderRoute: typeof AppApprovalsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/expenses': {
      id: '/_app/billing/expenses'
      path: '/billing/expenses'
      fullPath: '/billing/expenses'
      preLoaderRoute: typeof AppBillingExpensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/mileage': {
      id: '/_app/billing/mileage'
      path: '/billing/mileage'
      fullPath: '/billing/mileage'
      preLoaderRoute: typeof AppBillingMileageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/reports': {
      id: '/_app/billing/reports'
      path: '/billing/reports'
      fullPath: '/billing/reports'
      preLoaderRoute: typeof AppBillingReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/activity': {
      id: '/_app/dev/activity'
      path: '/dev/activity'
      fullPath: '/dev/activity'
      preLoaderRoute: typeof AppDevActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/board': {
      id: '/_app/dev/board'
      path: '/dev/board'
      fullPath: '/dev/board'
      preLoaderRoute: typeof AppDevBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/compliance': {
      id: '/_app/dev/compliance'
      path: '/dev/compliance'
      fullPath: '/dev/compliance'
      preLoaderRoute: typeof AppDevComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/milestones': {
      id: '/_app/dev/milestones'
      path: '/dev/milestones'
      fullPath: '/dev/milestones'
      preLoaderRoute: typeof AppDevMilestonesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/settings': {
      id: '/_app/dev/settings'
      path: '/dev/settings'
      fullPath: '/dev/settings'
      preLoaderRoute: typeof AppDevSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engagements/': {
      id: '/_app/engagements/'
      path: '/engagements'
      fullPath: '/engagements/'
      preLoaderRoute: typeof AppEngagementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engagements/$id': {
      id: '/_app/engagements/$id'
      path: '/engagements/$id'
      fullPath: '/engagements/$id'
      preLoaderRoute: typeof AppEngagementsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedback/': {
      id: '/_app/feedback/'
      path: '/feedback'
      fullPath: '/feedback/'
      preLoaderRoute: typeof AppFeedbackIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedback/$id': {
      id: '/_app/feedback/$id'
      path: '/feedback/$id'
      fullPath: '/feedback/$id'
      preLoaderRoute: typeof AppFeedbackIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/': {
      id: '/_app/knowledge/'
      path: '/knowledge'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof AppKnowledgeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/admin': {
      id: '/_app/knowledge/admin'
      path: '/knowledge/admin'
      fullPath: '/knowledge/admin'
      preLoaderRoute: typeof AppKnowledgeAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/search': {
      id: '/_app/knowledge/search'
      path: '/knowledge/search'
      fullPath: '/knowledge/search'
      preLoaderRoute: typeof AppKnowledgeSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/': {
      id: '/_app/org/'
      path: '/org'
      fullPath: '/org/'
      preLoaderRoute: typeof AppOrgIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/$id': {
      id: '/_app/org/$id'
      path: '/org/$id'
      fullPath: '/org/$id'
      preLoaderRoute: typeof AppOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id': {
      id: '/_app/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AppProjectsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/': {
      id: '/_app/proposals/'
      path: '/proposals'
      fullPath: '/proposals/'
      preLoaderRoute: typeof AppProposalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$id': {
      id: '/_app/proposals/$id'
      path: '/proposals/$id'
      fullPath: '/proposals/$id'
      preLoaderRoute: typeof AppProposalsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/': {
      id: '/_app/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AppSupportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/$id': {
      id: '/_app/support/$id'
      path: '/support/$id'
      fullPath: '/support/$id'
      preLoaderRoute: typeof AppSupportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/sla': {
      id: '/_app/support/sla'
      path: '/support/sla'
      fullPath: '/support/sla'
      preLoaderRoute: typeof AppSupportSlaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/templates': {
      id: '/_app/support/templates'
      path: '/support/templates'
      fullPath: '/support/templates'
      preLoaderRoute: typeof AppSupportTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/$id': {
      id: '/_app/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof AppTasksIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/': {
      id: '/_app/time/'
      path: '/time'
      fullPath: '/time/'
      preLoaderRoute: typeof AppTimeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/calendar': {
      id: '/_app/time/calendar'
      path: '/time/calendar'
      fullPath: '/time/calendar'
      preLoaderRoute: typeof AppTimeCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/drafts': {
      id: '/_app/time/drafts'
      path: '/time/drafts'
      fullPath: '/time/drafts'
      preLoaderRoute: typeof AppTimeDraftsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/week': {
      id: '/_app/time/week'
      path: '/time/week'
      fullPath: '/time/week'
      preLoaderRoute: typeof AppTimeWeekRouteImport
      parentRoute: typeof AppRoute
    }
    '/portal/_client/': {
      id: '/portal/_client/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalClientIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/issues': {
      id: '/portal/_client/issues'
      path: '/issues'
      fullPath: '/portal/issues'
      preLoaderRoute: typeof PortalClientIssuesRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/invite/$token': {
      id: '/portal/invite/$token'
      path: '/portal/invite/$token'
      fullPath: '/portal/invite/$token'
      preLoaderRoute: typeof PortalInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/choice-lists/': {
      id: '/_app/admin/choice-lists/'
      path: '/choice-lists'
      fullPath: '/admin/choice-lists/'
      preLoaderRoute: typeof AppAdminChoiceListsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/choice-lists/$id': {
      id: '/_app/admin/choice-lists/$id'
      path: '/choice-lists/$id'
      fullPath: '/admin/choice-lists/$id'
      preLoaderRoute: typeof AppAdminChoiceListsIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/jobs/': {
      id: '/_app/admin/jobs/'
      path: '/jobs'
      fullPath: '/admin/jobs/'
      preLoaderRoute: typeof AppAdminJobsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/jobs/$id': {
      id: '/_app/admin/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/admin/jobs/$id'
      preLoaderRoute: typeof AppAdminJobsIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/jobs/queue': {
      id: '/_app/admin/jobs/queue'
      path: '/jobs/queue'
      fullPath: '/admin/jobs/queue'
      preLoaderRoute: typeof AppAdminJobsQueueRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/': {
      id: '/_app/admin/roles/'
      path: '/roles'
      fullPath: '/admin/roles/'
      preLoaderRoute: typeof AppAdminRolesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/$id': {
      id: '/_app/admin/roles/$id'
      path: '/roles/$id'
      fullPath: '/admin/roles/$id'
      preLoaderRoute: typeof AppAdminRolesIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$id': {
      id: '/_app/admin/users/$id'
      path: '/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AppAdminUsersIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/agents/$id_/chat': {
      id: '/_app/agents/$id_/chat'
      path: '/agents/$id/chat'
      fullPath: '/agents/$id/chat'
      preLoaderRoute: typeof AppAgentsIdChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/runs/': {
      id: '/_app/agents/runs/'
      path: '/agents/runs'
      fullPath: '/agents/runs/'
      preLoaderRoute: typeof AppAgentsRunsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/runs/$id': {
      id: '/_app/agents/runs/$id'
      path: '/agents/runs/$id'
      fullPath: '/agents/runs/$id'
      preLoaderRoute: typeof AppAgentsRunsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/tasks/': {
      id: '/_app/agents/tasks/'
      path: '/agents/tasks'
      fullPath: '/agents/tasks/'
      preLoaderRoute: typeof AppAgentsTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/tasks/$id': {
      id: '/_app/agents/tasks/$id'
      path: '/agents/tasks/$id'
      fullPath: '/agents/tasks/$id'
      preLoaderRoute: typeof AppAgentsTasksIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/invoices/': {
      id: '/_app/billing/invoices/'
      path: '/billing/invoices'
      fullPath: '/billing/invoices/'
      preLoaderRoute: typeof AppBillingInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/invoices/$id': {
      id: '/_app/billing/invoices/$id'
      path: '/billing/invoices/$id'
      fullPath: '/billing/invoices/$id'
      preLoaderRoute: typeof AppBillingInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm/leads/': {
      id: '/_app/crm/leads/'
      path: '/crm/leads'
      fullPath: '/crm/leads/'
      preLoaderRoute: typeof AppCrmLeadsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm/leads/$id': {
      id: '/_app/crm/leads/$id'
      path: '/crm/leads/$id'
      fullPath: '/crm/leads/$id'
      preLoaderRoute: typeof AppCrmLeadsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm/meetings/': {
      id: '/_app/crm/meetings/'
      path: '/crm/meetings'
      fullPath: '/crm/meetings/'
      preLoaderRoute: typeof AppCrmMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crm/meetings/$id': {
      id: '/_app/crm/meetings/$id'
      path: '/crm/meetings/$id'
      fullPath: '/crm/meetings/$id'
      preLoaderRoute: typeof AppCrmMeetingsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/issues/': {
      id: '/_app/dev/issues/'
      path: '/dev/issues'
      fullPath: '/dev/issues/'
      preLoaderRoute: typeof AppDevIssuesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/issues/$id': {
      id: '/_app/dev/issues/$id'
      path: '/dev/issues/$id'
      fullPath: '/dev/issues/$id'
      preLoaderRoute: typeof AppDevIssuesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/milestones_/$id': {
      id: '/_app/dev/milestones_/$id'
      path: '/dev/milestones/$id'
      fullPath: '/dev/milestones/$id'
      preLoaderRoute: typeof AppDevMilestonesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/pulls/': {
      id: '/_app/dev/pulls/'
      path: '/dev/pulls'
      fullPath: '/dev/pulls/'
      preLoaderRoute: typeof AppDevPullsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/pulls/$id': {
      id: '/_app/dev/pulls/$id'
      path: '/dev/pulls/$id'
      fullPath: '/dev/pulls/$id'
      preLoaderRoute: typeof AppDevPullsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/documents/$id': {
      id: '/_app/knowledge/documents/$id'
      path: '/knowledge/documents/$id'
      fullPath: '/knowledge/documents/$id'
      preLoaderRoute: typeof AppKnowledgeDocumentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/entities/': {
      id: '/_app/knowledge/entities/'
      path: '/knowledge/entities'
      fullPath: '/knowledge/entities/'
      preLoaderRoute: typeof AppKnowledgeEntitiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/entities/$id': {
      id: '/_app/knowledge/entities/$id'
      path: '/knowledge/entities/$id'
      fullPath: '/knowledge/entities/$id'
      preLoaderRoute: typeof AppKnowledgeEntitiesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge/items/$id': {
      id: '/_app/knowledge/items/$id'
      path: '/knowledge/items/$id'
      fullPath: '/knowledge/items/$id'
      preLoaderRoute: typeof AppKnowledgeItemsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/articles/': {
      id: '/_app/support/articles/'
      path: '/support/articles'
      fullPath: '/support/articles/'
      preLoaderRoute: typeof AppSupportArticlesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/articles/$id': {
      id: '/_app/support/articles/$id'
      path: '/support/articles/$id'
      fullPath: '/support/articles/$id'
      preLoaderRoute: typeof AppSupportArticlesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/day/$date': {
      id: '/_app/time/day/$date'
      path: '/time/day/$date'
      fullPath: '/time/day/$date'
      preLoaderRoute: typeof AppTimeDayDateRouteImport
      parentRoute: typeof AppRoute
    }
    '/portal/_client/articles/': {
      id: '/portal/_client/articles/'
      path: '/articles'
      fullPath: '/portal/articles/'
      preLoaderRoute: typeof PortalClientArticlesIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/articles/$id': {
      id: '/portal/_client/articles/$id'
      path: '/articles/$id'
      fullPath: '/portal/articles/$id'
      preLoaderRoute: typeof PortalClientArticlesIdRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/hours/': {
      id: '/portal/_client/hours/'
      path: '/hours'
      fullPath: '/portal/hours/'
      preLoaderRoute: typeof PortalClientHoursIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/hours/$id': {
      id: '/portal/_client/hours/$id'
      path: '/hours/$id'
      fullPath: '/portal/hours/$id'
      preLoaderRoute: typeof PortalClientHoursIdRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/invoices/': {
      id: '/portal/_client/invoices/'
      path: '/invoices'
      fullPath: '/portal/invoices/'
      preLoaderRoute: typeof PortalClientInvoicesIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/projects/': {
      id: '/portal/_client/projects/'
      path: '/projects'
      fullPath: '/portal/projects/'
      preLoaderRoute: typeof PortalClientProjectsIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/projects/$id': {
      id: '/portal/_client/projects/$id'
      path: '/projects/$id'
      fullPath: '/portal/projects/$id'
      preLoaderRoute: typeof PortalClientProjectsIdRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/proposals/': {
      id: '/portal/_client/proposals/'
      path: '/proposals'
      fullPath: '/portal/proposals/'
      preLoaderRoute: typeof PortalClientProposalsIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/proposals/$id': {
      id: '/portal/_client/proposals/$id'
      path: '/proposals/$id'
      fullPath: '/portal/proposals/$id'
      preLoaderRoute: typeof PortalClientProposalsIdRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/tickets/': {
      id: '/portal/_client/tickets/'
      path: '/tickets'
      fullPath: '/portal/tickets/'
      preLoaderRoute: typeof PortalClientTicketsIndexRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/tickets/$id': {
      id: '/portal/_client/tickets/$id'
      path: '/tickets/$id'
      fullPath: '/portal/tickets/$id'
      preLoaderRoute: typeof PortalClientTicketsIdRouteImport
      parentRoute: typeof PortalClientRoute
    }
    '/portal/_client/tickets/new': {
      id: '/portal/_client/tickets/new'
      path: '/tickets/new'
      fullPath: '/portal/tickets/new'
      preLoaderRoute: typeof PortalClientTicketsNewRouteImport
      parentRoute: typeof PortalClientRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminApiCallsRoute: typeof AppAdminApiCallsRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminCompanyRoute: typeof AppAdminCompanyRoute
  AppAdminConnectionsRoute: typeof AppAdminConnectionsRoute
  AppAdminInboundMailsRoute: typeof AppAdminInboundMailsRoute
  AppAdminInboundRecordingsRoute: typeof AppAdminInboundRecordingsRoute
  AppAdminMailboxesRoute: typeof AppAdminMailboxesRoute
  AppAdminSchedulesRoute: typeof AppAdminSchedulesRoute
  AppAdminSecretsRoute: typeof AppAdminSecretsRoute
  AppAdminTemplatesRoute: typeof AppAdminTemplatesRoute
  AppAdminWebhooksRoute: typeof AppAdminWebhooksRoute
  AppAdminWorkTypesRoute: typeof AppAdminWorkTypesRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminChoiceListsIdRoute: typeof AppAdminChoiceListsIdRoute
  AppAdminJobsIdRoute: typeof AppAdminJobsIdRoute
  AppAdminJobsQueueRoute: typeof AppAdminJobsQueueRoute
  AppAdminRolesIdRoute: typeof AppAdminRolesIdRoute
  AppAdminUsersIdRoute: typeof AppAdminUsersIdRoute
  AppAdminChoiceListsIndexRoute: typeof AppAdminChoiceListsIndexRoute
  AppAdminJobsIndexRoute: typeof AppAdminJobsIndexRoute
  AppAdminRolesIndexRoute: typeof AppAdminRolesIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminApiCallsRoute: AppAdminApiCallsRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminCompanyRoute: AppAdminCompanyRoute,
  AppAdminConnectionsRoute: AppAdminConnectionsRoute,
  AppAdminInboundMailsRoute: AppAdminInboundMailsRoute,
  AppAdminInboundRecordingsRoute: AppAdminInboundRecordingsRoute,
  AppAdminMailboxesRoute: AppAdminMailboxesRoute,
  AppAdminSchedulesRoute: AppAdminSchedulesRoute,
  AppAdminSecretsRoute: AppAdminSecretsRoute,
  AppAdminTemplatesRoute: AppAdminTemplatesRoute,
  AppAdminWebhooksRoute: AppAdminWebhooksRoute,
  AppAdminWorkTypesRoute: AppAdminWorkTypesRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminChoiceListsIdRoute: AppAdminChoiceListsIdRoute,
  AppAdminJobsIdRoute: AppAdminJobsIdRoute,
  AppAdminJobsQueueRoute: AppAdminJobsQueueRoute,
  AppAdminRolesIdRoute: AppAdminRolesIdRoute,
  AppAdminUsersIdRoute: AppAdminUsersIdRoute,
  AppAdminChoiceListsIndexRoute: AppAdminChoiceListsIndexRoute,
  AppAdminJobsIndexRoute: AppAdminJobsIndexRoute,
  AppAdminRolesIndexRoute: AppAdminRolesIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAgendaRoute: typeof AppAgendaRoute
  AppInboxRoute: typeof AppInboxRoute
  AppMyWorkRoute: typeof AppMyWorkRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppWerkRoute: typeof AppWerkRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAgentsIdRoute: typeof AppAgentsIdRoute
  AppAgentsInsightsRoute: typeof AppAgentsInsightsRoute
  AppAgentsRoutinesRoute: typeof AppAgentsRoutinesRoute
  AppAgreementsIdRoute: typeof AppAgreementsIdRoute
  AppApprovalsIdRoute: typeof AppApprovalsIdRoute
  AppBillingExpensesRoute: typeof AppBillingExpensesRoute
  AppBillingMileageRoute: typeof AppBillingMileageRoute
  AppBillingReportsRoute: typeof AppBillingReportsRoute
  AppDevActivityRoute: typeof AppDevActivityRoute
  AppDevBoardRoute: typeof AppDevBoardRoute
  AppDevComplianceRoute: typeof AppDevComplianceRoute
  AppDevMilestonesRoute: typeof AppDevMilestonesRoute
  AppDevSettingsRoute: typeof AppDevSettingsRoute
  AppEngagementsIdRoute: typeof AppEngagementsIdRoute
  AppFeedbackIdRoute: typeof AppFeedbackIdRoute
  AppKnowledgeAdminRoute: typeof AppKnowledgeAdminRoute
  AppKnowledgeSearchRoute: typeof AppKnowledgeSearchRoute
  AppOrgIdRoute: typeof AppOrgIdRoute
  AppProjectsIdRoute: typeof AppProjectsIdRoute
  AppProposalsIdRoute: typeof AppProposalsIdRoute
  AppSupportIdRoute: typeof AppSupportIdRoute
  AppSupportSlaRoute: typeof AppSupportSlaRoute
  AppSupportTemplatesRoute: typeof AppSupportTemplatesRoute
  AppTasksIdRoute: typeof AppTasksIdRoute
  AppTimeCalendarRoute: typeof AppTimeCalendarRoute
  AppTimeDraftsRoute: typeof AppTimeDraftsRoute
  AppTimeWeekRoute: typeof AppTimeWeekRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppAgreementsIndexRoute: typeof AppAgreementsIndexRoute
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
  AppEngagementsIndexRoute: typeof AppEngagementsIndexRoute
  AppFeedbackIndexRoute: typeof AppFeedbackIndexRoute
  AppKnowledgeIndexRoute: typeof AppKnowledgeIndexRoute
  AppOrgIndexRoute: typeof AppOrgIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppProposalsIndexRoute: typeof AppProposalsIndexRoute
  AppSupportIndexRoute: typeof AppSupportIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppTimeIndexRoute: typeof AppTimeIndexRoute
  AppAgentsIdChatRoute: typeof AppAgentsIdChatRoute
  AppAgentsRunsIdRoute: typeof AppAgentsRunsIdRoute
  AppAgentsTasksIdRoute: typeof AppAgentsTasksIdRoute
  AppBillingInvoicesIdRoute: typeof AppBillingInvoicesIdRoute
  AppCrmLeadsIdRoute: typeof AppCrmLeadsIdRoute
  AppCrmMeetingsIdRoute: typeof AppCrmMeetingsIdRoute
  AppDevIssuesIdRoute: typeof AppDevIssuesIdRoute
  AppDevMilestonesIdRoute: typeof AppDevMilestonesIdRoute
  AppDevPullsIdRoute: typeof AppDevPullsIdRoute
  AppKnowledgeDocumentsIdRoute: typeof AppKnowledgeDocumentsIdRoute
  AppKnowledgeEntitiesIdRoute: typeof AppKnowledgeEntitiesIdRoute
  AppKnowledgeItemsIdRoute: typeof AppKnowledgeItemsIdRoute
  AppSupportArticlesIdRoute: typeof AppSupportArticlesIdRoute
  AppTimeDayDateRoute: typeof AppTimeDayDateRoute
  AppAgentsRunsIndexRoute: typeof AppAgentsRunsIndexRoute
  AppAgentsTasksIndexRoute: typeof AppAgentsTasksIndexRoute
  AppBillingInvoicesIndexRoute: typeof AppBillingInvoicesIndexRoute
  AppCrmLeadsIndexRoute: typeof AppCrmLeadsIndexRoute
  AppCrmMeetingsIndexRoute: typeof AppCrmMeetingsIndexRoute
  AppDevIssuesIndexRoute: typeof AppDevIssuesIndexRoute
  AppDevPullsIndexRoute: typeof AppDevPullsIndexRoute
  AppKnowledgeEntitiesIndexRoute: typeof AppKnowledgeEntitiesIndexRoute
  AppSupportArticlesIndexRoute: typeof AppSupportArticlesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAgendaRoute: AppAgendaRoute,
  AppInboxRoute: AppInboxRoute,
  AppMyWorkRoute: AppMyWorkRoute,
  AppReportsRoute: AppReportsRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppWerkRoute: AppWerkRoute,
  AppIndexRoute: AppIndexRoute,
  AppAgentsIdRoute: AppAgentsIdRoute,
  AppAgentsInsightsRoute: AppAgentsInsightsRoute,
  AppAgentsRoutinesRoute: AppAgentsRoutinesRoute,
  AppAgreementsIdRoute: AppAgreementsIdRoute,
  AppApprovalsIdRoute: AppApprovalsIdRoute,
  AppBillingExpensesRoute: AppBillingExpensesRoute,
  AppBillingMileageRoute: AppBillingMileageRoute,
  AppBillingReportsRoute: AppBillingReportsRoute,
  AppDevActivityRoute: AppDevActivityRoute,
  AppDevBoardRoute: AppDevBoardRoute,
  AppDevComplianceRoute: AppDevComplianceRoute,
  AppDevMilestonesRoute: AppDevMilestonesRoute,
  AppDevSettingsRoute: AppDevSettingsRoute,
  AppEngagementsIdRoute: AppEngagementsIdRoute,
  AppFeedbackIdRoute: AppFeedbackIdRoute,
  AppKnowledgeAdminRoute: AppKnowledgeAdminRoute,
  AppKnowledgeSearchRoute: AppKnowledgeSearchRoute,
  AppOrgIdRoute: AppOrgIdRoute,
  AppProjectsIdRoute: AppProjectsIdRoute,
  AppProposalsIdRoute: AppProposalsIdRoute,
  AppSupportIdRoute: AppSupportIdRoute,
  AppSupportSlaRoute: AppSupportSlaRoute,
  AppSupportTemplatesRoute: AppSupportTemplatesRoute,
  AppTasksIdRoute: AppTasksIdRoute,
  AppTimeCalendarRoute: AppTimeCalendarRoute,
  AppTimeDraftsRoute: AppTimeDraftsRoute,
  AppTimeWeekRoute: AppTimeWeekRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppAgreementsIndexRoute: AppAgreementsIndexRoute,
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
  AppEngagementsIndexRoute: AppEngagementsIndexRoute,
  AppFeedbackIndexRoute: AppFeedbackIndexRoute,
  AppKnowledgeIndexRoute: AppKnowledgeIndexRoute,
  AppOrgIndexRoute: AppOrgIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppProposalsIndexRoute: AppProposalsIndexRoute,
  AppSupportIndexRoute: AppSupportIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppTimeIndexRoute: AppTimeIndexRoute,
  AppAgentsIdChatRoute: AppAgentsIdChatRoute,
  AppAgentsRunsIdRoute: AppAgentsRunsIdRoute,
  AppAgentsTasksIdRoute: AppAgentsTasksIdRoute,
  AppBillingInvoicesIdRoute: AppBillingInvoicesIdRoute,
  AppCrmLeadsIdRoute: AppCrmLeadsIdRoute,
  AppCrmMeetingsIdRoute: AppCrmMeetingsIdRoute,
  AppDevIssuesIdRoute: AppDevIssuesIdRoute,
  AppDevMilestonesIdRoute: AppDevMilestonesIdRoute,
  AppDevPullsIdRoute: AppDevPullsIdRoute,
  AppKnowledgeDocumentsIdRoute: AppKnowledgeDocumentsIdRoute,
  AppKnowledgeEntitiesIdRoute: AppKnowledgeEntitiesIdRoute,
  AppKnowledgeItemsIdRoute: AppKnowledgeItemsIdRoute,
  AppSupportArticlesIdRoute: AppSupportArticlesIdRoute,
  AppTimeDayDateRoute: AppTimeDayDateRoute,
  AppAgentsRunsIndexRoute: AppAgentsRunsIndexRoute,
  AppAgentsTasksIndexRoute: AppAgentsTasksIndexRoute,
  AppBillingInvoicesIndexRoute: AppBillingInvoicesIndexRoute,
  AppCrmLeadsIndexRoute: AppCrmLeadsIndexRoute,
  AppCrmMeetingsIndexRoute: AppCrmMeetingsIndexRoute,
  AppDevIssuesIndexRoute: AppDevIssuesIndexRoute,
  AppDevPullsIndexRoute: AppDevPullsIndexRoute,
  AppKnowledgeEntitiesIndexRoute: AppKnowledgeEntitiesIndexRoute,
  AppSupportArticlesIndexRoute: AppSupportArticlesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PortalClientRouteChildren {
  PortalClientIssuesRoute: typeof PortalClientIssuesRoute
  PortalClientIndexRoute: typeof PortalClientIndexRoute
  PortalClientArticlesIdRoute: typeof PortalClientArticlesIdRoute
  PortalClientHoursIdRoute: typeof PortalClientHoursIdRoute
  PortalClientProjectsIdRoute: typeof PortalClientProjectsIdRoute
  PortalClientProposalsIdRoute: typeof PortalClientProposalsIdRoute
  PortalClientTicketsIdRoute: typeof PortalClientTicketsIdRoute
  PortalClientTicketsNewRoute: typeof PortalClientTicketsNewRoute
  PortalClientArticlesIndexRoute: typeof PortalClientArticlesIndexRoute
  PortalClientHoursIndexRoute: typeof PortalClientHoursIndexRoute
  PortalClientInvoicesIndexRoute: typeof PortalClientInvoicesIndexRoute
  PortalClientProjectsIndexRoute: typeof PortalClientProjectsIndexRoute
  PortalClientProposalsIndexRoute: typeof PortalClientProposalsIndexRoute
  PortalClientTicketsIndexRoute: typeof PortalClientTicketsIndexRoute
}

const PortalClientRouteChildren: PortalClientRouteChildren = {
  PortalClientIssuesRoute: PortalClientIssuesRoute,
  PortalClientIndexRoute: PortalClientIndexRoute,
  PortalClientArticlesIdRoute: PortalClientArticlesIdRoute,
  PortalClientHoursIdRoute: PortalClientHoursIdRoute,
  PortalClientProjectsIdRoute: PortalClientProjectsIdRoute,
  PortalClientProposalsIdRoute: PortalClientProposalsIdRoute,
  PortalClientTicketsIdRoute: PortalClientTicketsIdRoute,
  PortalClientTicketsNewRoute: PortalClientTicketsNewRoute,
  PortalClientArticlesIndexRoute: PortalClientArticlesIndexRoute,
  PortalClientHoursIndexRoute: PortalClientHoursIndexRoute,
  PortalClientInvoicesIndexRoute: PortalClientInvoicesIndexRoute,
  PortalClientProjectsIndexRoute: PortalClientProjectsIndexRoute,
  PortalClientProposalsIndexRoute: PortalClientProposalsIndexRoute,
  PortalClientTicketsIndexRoute: PortalClientTicketsIndexRoute,
}

const PortalClientRouteWithChildren = PortalClientRoute._addFileChildren(
  PortalClientRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ConsentRoute: ConsentRoute,
  LoginRoute: LoginRoute,
  PortalClientRoute: PortalClientRouteWithChildren,
  PortalLoginRoute: PortalLoginRoute,
  PortalPrivacyRoute: PortalPrivacyRoute,
  PortalInviteTokenRoute: PortalInviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
